import {fabric} from 'fabric';

import './ProductRender.scss'

export class ProductRender {

    constructor(options = {}) {
        let defaults = {
            canvasId:        'product-render',
            wrapperSelector: '.product-render',
            baseWidth:       100,
            baseHeight:      100,
            canvasOptions: {
                preserveObjectStacking: true,
                selection:              false
            }
        }

        this.options = Object.assign({}, defaults, options);

        let canvasDom = document.getElementById(this.options.canvasId)

        if (canvasDom === null) {
            console.error(`Element with id: "${this.options.canvasId}" not found`)

            return
        }

        this.canvasDom = canvasDom

        this.fabricInit()
    }

    fabricInit = () => {
        this.canvas = new fabric.Canvas(this.options.canvasId, this.options.canvasOptions)

        this.canvas.setDimensions({
            width:  this.options.baseWidth,
            height: this.options.baseHeight
        })

        this.resizeCanvas()

        window.addEventListener('resize', this.resizeCanvas)
    }

    getWrapper = () => {
        return this.canvasDom.closest(this.options.wrapperSelector)
    }

    resizeCanvas = () => {
        const containerWidth = this.getWrapper().clientWidth
        const containerHeight = this.getWrapper().clientHeight

        this.setCanvasDimension(containerWidth, containerHeight)
    }

    setCanvasDimension = (width, height) => {
        const scale = width / this.canvas.getWidth()
        const zoom = this.canvas.getZoom() * scale

        this.canvas.setDimensions({
            width:  width,
            height: height
        })
        this.canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
    }

    getImage = (width = 1280, height = 1280) => {
        this.setCanvasDimension(width, height)

        const src = this.canvas.toDataURL('image/png')

        this.resizeCanvas()

        return src
    }
}